import { theme } from 'theme'
import { Box } from 'rebass'
import styled from 'particles/themes/styled'
import Popup from 'reactjs-popup'
import Button from 'components/Shared/Button/OldButton'

export const StyledPopup = styled(Popup)`
    &-content {
        border-radius: 8px;
        box-shadow:
            0px 11px 15px rgba(0, 0, 0, 0.2),
            0px 24px 38px rgba(0, 0, 0, 0.14),
            0px 9px 46px rgba(0, 0, 0, 0.12);
        overflow: auto;
        max-height: 95vh;
    }
`

export const PartiTooltip = styled(Box)`
    .box {
        background: white;
        color: black;
        border-radius: 0.5em;
        font-size: 1em;
    }
    .close__button {
        position: absolute;
        right: 0;
        top: 0;
    }
`

export const TooltipButton = styled(Button)`
    &:hover div {
        font-weight: bold;
        color: ${theme.colors.astronaut};
    }
`
